import Vue from 'vue'
import axios from 'axios'
import store from '../store/store'
import router from '../router'
import { setItem } from "@/helpers/storage-manager"
const {EventBus} = require('./eventBus');

let isRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  });

  failedQueue = []
}

const instance = axios.create({
  baseURL: process.env.VUE_APP_API
})

instance.interceptors.request.use( async config => {
  //Vue.prototype.$Progress.start()
  store.commit('loader/addRequest')

  if (Vue.prototype.$auth.isAuthenticated()) {
    config.headers['Authorization'] = [
      Vue.prototype.$auth.options.tokenType, Vue.prototype.$auth.getToken()
    ].join(' ')
  } else {
    delete config.headers['Authorization']
  }

  return config
}, error => {
  return Promise.reject(error)
})

instance.interceptors.response.use(response => {
  store.commit('loader/subtractRequest')
  return response
}, async(error) => {
  if (error instanceof axios.Cancel) { return router.push({ name: 'root' }).catch(() => {})}
  store.commit('loader/subtractRequest')

  const originalRequest = error.config
  const { response = {} } = error
  if (response.status === 400) return new Error('Ha ocurrido un error')
  if (response.status === 403) {return router.push({ name: 'NoAccess' }).catch(() => {})}

  if (response.status !== 401 || originalRequest._retry) return Promise.resolve(error)
  if (!isRefreshing) {
    isRefreshing = true
    await refreshAccessToken()
  }

  originalRequest._retry = true

  return new Promise((resolve, reject) => {
    EventBus.$once('updatedToken', async(error, token) => {
      if (error) {
        console.log('error', error)
        router.push({ name: 'logout' }).catch((e) => e)
        return reject(error)
      }
      originalRequest.headers['Authorization'] = 'Bearer ' + token
      resolve(await axios(originalRequest))
    })
  })
})

export default {
  install(Vue) {
    Vue.request = instance
    Vue.prototype.$request = instance
  }
}

const refreshAccessToken = async () => {
  try {
    const refreshToken = Vue.prototype.$getCookie('refreshToken')
    if (!refreshToken) return await router.push({ name: 'logout' })

    const api = axios.create({
      baseURL: process.env.VUE_APP_API,
      headers: { 'Authorization': 'Bearer ' + refreshToken }
    })

    const { data } = await api.get('token/refresh')
    setItem('botlers.konverza_token', data.token)
    isRefreshing = false
    EventBus.$emit('updatedToken', null, data.token)
    return data.token
  } catch (error) {
    console.log(error)
    EventBus.$emit('updatedToken', error,null)
    throw new Error('Failed to refresh access token')
  }
};

export const getRefreshToken = refreshAccessToken